const LOCAL_STORAGE_KEY = "theme";
const HTML_CLASS_DARK = "dark";
const HTML_CLASS_LIGHT = "light";

export default defineNuxtPlugin((nuxtApp) => {
  const isDark = useState<boolean>("isDark", () => {
    if (!import.meta.client) {
      return false;
    }

    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: light)"
    ).matches;

    if (stored === HTML_CLASS_DARK) {
      return true;
    }

    if (stored === HTML_CLASS_LIGHT) {
      return false;
    }

    return prefersDark;
  });

  const toggleDarkMode = () => {
    isDark.value = !isDark.value;
    if (import.meta.client) {
      const html = document.documentElement;
      if (isDark.value) {
        html.classList.add(HTML_CLASS_DARK);
        localStorage.setItem(LOCAL_STORAGE_KEY, HTML_CLASS_DARK);
      } else {
        html.classList.remove(HTML_CLASS_DARK);
        localStorage.setItem(LOCAL_STORAGE_KEY, HTML_CLASS_LIGHT);
      }
    }
  };

  // Ensure class is applied on init
  if (import.meta.client) {
    const html = document.documentElement;
    if (isDark.value) {
      html.classList.add(HTML_CLASS_DARK);
    } else {
      html.classList.remove(HTML_CLASS_DARK);
    }
  }

  nuxtApp.provide("darkMode", {
    isDark,
    toggleDarkMode,
  });
});
